/* eslint-disable no-empty, no-restricted-globals, no-param-reassign */
import { getContainerData, loadMorePosts, loadData } from '../helpers/more';
import shared from './shared';

let activeFilters = [];

function clearButtonsState(buttons) {
  [].forEach.call(buttons, button => {
    button.classList.remove(shared.CSS.active);
  });
}

function loadCategoryPosts(container, dataContainer, categoryId) {
  container.classList.add(shared.CSS.loading);
  const token = new Date().getTime();
  const data = {
    postType: 'post',
    postsPerPage: 10,
    page: 1,
    offset: 0,
    category: categoryId,
  };
  container.setAttribute('data-token', token);

  loadData({
    url: window.ELEFINT.ajaxURL,
    data,
    success: response => {
      const currentToken = parseInt(container.getAttribute('data-token'), 10);

      if (currentToken !== token) {
        return;
      }

      try {
        const json = JSON.parse(response);
        dataContainer.innerHTML = json.posts;
        container.setAttribute('data-page', 1);

        if (json.hasMore === false) {
          container.classList.add('no-more-button');
        } else {
          container.classList.remove('no-more-button');
        }
      } catch (e) {}

      container.classList.remove(shared.CSS.loading);
    },
  });
}

function prepareFiltering(container) {
  let activeFilter = null;
  const sortButton = container.querySelector('.c-posts__filter-sort');
  const categoryButtons = container.querySelectorAll('.c-posts__filter-button');

  if (sortButton !== null) {
    sortButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      const filterElement = event.currentTarget.parentNode;

      if (filterElement !== activeFilter && activeFilter !== null) {
        activeFilter.classList.remove(shared.CSS.active);
      }

      filterElement.classList.toggle(shared.CSS.active);

      if (filterElement.classList.contains(shared.CSS.active)) {
        activeFilter = filterElement;
        activeFilters.push(filterElement);
      } else {
        activeFilter = null;
      }
    });
  }

  if (categoryButtons.length > 0) {
    [].forEach.call(categoryButtons, categoryButton => {
      categoryButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        if (activeFilter !== null) {
          activeFilter.classList.remove(shared.CSS.active);
        }

        if (categoryButton.classList.contains(shared.CSS.active)) {
          return;
        }

        let category = parseInt(
          categoryButton.getAttribute('data-category-id'),
          10,
        );

        if (isNaN(category)) {
          category = 0;
        }

        if (
          category !== parseInt(container.getAttribute('data-category-id'), 10)
        ) {
          clearButtonsState(categoryButtons);
          container.setAttribute('data-category-id', category);
          if (category > 0) {
            categoryButton.classList.add(shared.CSS.active);
          }

          loadCategoryPosts(
            container,
            container.querySelector(container.getAttribute('data-container')),
            category,
          );
        }
      });
    });
  }
}

export default () => {
  const sections = document.querySelectorAll('.c-posts');

  if (sections.length < 1) {
    return;
  }

  document.body.addEventListener('click', () => {
    if (activeFilters.length > 0) {
      [].forEach.call(activeFilters, filter => {
        filter.classList.remove(shared.CSS.active);
      });

      activeFilters = [];
    }
  });

  [].forEach.call(sections, section => {
    let data = getContainerData(section);

    if (data.dataContainer === null || data.container === null) {
      return;
    }

    prepareFiltering(section);

    if (data.button === null) {
      return;
    }

    data.button.addEventListener('click', event => {
      event.preventDefault();
      data = getContainerData(section);

      data.info.offset = data.dataContainer.children.length;

      if (window.innerWidth > 1023 && data.info.page === 1) {
        data.info.postsPerPage = 8;
      } else if (window.innerWidth < 1024) {
        data.info.postsPerPage = data.info.postsPerPageMobile || 10;
      }

      if (data.info.page < 2) {
        data.info.page = 2;
      }

      loadMorePosts(data);
    });
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/posts.js